<template>
  <div
    class="link-crumb"
    :style="crumbStyle"
  >
    <ul
      ref="crumbList"
      class="link-crumb-list"
      @click="itemClick"
    >
      <li
        v-show="isShowBack"
        ref="goBack"
        class="link-crumb-content"
        back="goBack"
      >
        <div class="link-crumb-item go-back">
          <span
            class="path-name"
            back="goBack"
          >{{ $t('返回') }}<span class="back-sepreator">|</span></span>
        </div>
      </li>
      <li class="link-crumb-content">
        <crumb-item
          :wider-than-parent="widerThanParent"
          :item-data="getRootData"
          :item-max-width="itemMaxWidth"
          :crumb-width="crumbWidth"
          :is-showlist="isShowlist"
          :crumb-len="getCrumbData.length"
          index="0"
          :width-rate="widthRate"
        />
      </li>
      <li
        v-if="isShowlist"
        ref="listMore"
        class="link-crumb-content"
      >
        <crumb-list
          ref="crumbMore"
          :list-data="getListData"
        />
      </li>
      <li
        v-for="(item, index) of getCrumbData"
        :key="index"
        class="link-crumb-content"
      >
        <crumb-item
          :item-data="item"
          :wider-than-parent="widerThanParent"
          :item-max-width="itemMaxWidth"
          :crumb-width="crumbWidth"
          :is-showlist="isShowlist"
          :crumb-len="getCrumbData.length"
          :item-offset="itemOffset"
          :index="index"
          :width-rate="widthRate"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import CrumbItem from 'components/business/link/crumb/crumb-item.vue'
import CrumbList from 'components/business/link/crumb/crumb-list.vue'

const ItemMaxWidth = 76
export default {
  name: 'Crumb',
  components: {
    CrumbItem,
    CrumbList,
  },
  props: {
    thirdParty: Boolean,
    fileList: Object,
    path: String,
    curbMap: Array,
    getCrumbWidth: Function,
    crumbWidth: 0,
  },
  data() {
    return {
      itemWidth: 100,
      widthRate: 1,
      isShowlist: false,
      timeHandler: null,
      itemMaxWidth: 0,
      // 表示中间应该去掉几个
      itemOffset: 0,
      contentWidth: 0,
      // lastItemWidth: 0,
      // 是否有小于最小长度的
      hasMinItem: false,
      widerThanParent: false,
    }
  },
  computed: {
    isShowBack() {
      if (!this.curbMap) return false
      return this.curbMap.length > 1
    },
    rootName() {
      if (this.thirdParty && this.fileList.delivery_creator) {
        return this.$t('{n}的审批文件', { n: this.fileList.delivery_creator })
      }
      return this.$t('{n}的分享', { n: this.fileList.delivery_creator })
    },
    getRootData() {
      if (!this.curbMap) return {}
      const root = { ...this.curbMap[0], path: this.rootName || '' }
      return root
    },
    getListData() {
      const data = [].concat(this.curbMap)
      return data.slice(1, this.itemOffset + 1)
    },
    // 获取...中列表的数据
    // 获取显示在面包屑上的数据
    getCrumbData() {
      const data = [].concat(this.curbMap)
      data.splice(0, 1)
      if (this.itemOffset) {
        return data.slice(this.itemOffset)
      }
      return data
    },
    crumbStyle() {
      return {
        // 'max-width': `${this.crumbWidth}px`
        width: `${this.crumbWidth}px`,
      }
    },
  },
  watch: {
    curbMap: {
      handler() {
        this.$nextTick(() => {
          this.setListWidth()
        })
      },
      immediate: true,
    },
  },
  mounted() {
    window.addEventListener('resize', this.resizeHandler)
    this.setListWidth()
  },
  methods: {
    // 这一部分逻辑本来想计算总的长度，求一个比率，来缩小每一层，
    // 但是这里拿到的dom和每一层里边的实际dom有出入，暂时不可取
    // 获取子元素实际宽度（包含超出的部分）
    getContentWidth(refresh) {
      const ul = this.$refs.crumbList
      if (!ul) return 0
      let arr = ul.children || ul.childNodes
      arr = [...arr]
      let result = 0
      let minTag = false
      arr = arr.slice(1)
      arr.forEach((v, i) => {
        const children = [...v.getElementsByTagName('span')]
        if (v.offsetWidth < ItemMaxWidth) {
          minTag = true
        }
        children.forEach((ele, i) => {
          result += ele.offsetWidth
        })
      })
      // 刷新minTag，只有在setListWidth重新设置面包屑长度的时候会刷新
      if (refresh) {
        this.hasMinItem = minTag
      }
      return result
    },
    // 获取子元素实际宽度（不包含超出的部分）
    // getCurContentWidth() {
    //     let ul = this.$refs.crumbList
    //     if (!ul) return 0
    //     let arr = ul.children || ul.childNodes
    //     arr = [...arr]
    //     let result = 0
    //     arr = arr.slice(1)
    //     arr.forEach((v, i) => {
    //         result += v.offsetWidth
    //     })
    //     return result
    // },
    // 获取...后边元素的偏移量
    setOffset(len, parentWidth) {
      if (document.body.offsetWidth <= 1024) {
        this.itemOffset = len - 2
        return
      }
      let moreWidth = 0
      if (this.isShowlist) {
        // 这里需要去掉...的长度，但是这里dom还没有，如果下一帧就晚了，别的长度也不会超过了，所以直接给了宽度
        moreWidth = 54
      }
      const lenWidth = len * ItemMaxWidth
      const gap = lenWidth - parentWidth + moreWidth
      const itemOffset = Math.ceil(gap / ItemMaxWidth)
      if (itemOffset < 1) {
        // 处理中间有一条过短的情况
        this.itemOffset = 1
      } else {
        this.itemOffset = itemOffset
        this.lastItemWidth = 0
      }
    },
    // 更新面包屑自适应
    setListWidth() {
      let backWidth = 0
      if (this.isShowBack) {
        backWidth = this.$refs.goBack ? this.$refs.goBack.offsetWidth : 50
      }
      const ul = this.$refs.crumbList
      // 父级ul的长度
      const parentWidth = ul.offsetWidth - backWidth

      // this.widthRate = (contentWidth / parentWidth) || 1
      this.itemOffset = 0
      this.$nextTick(() => {
        // 中间内容li的总长度
        const contentWidth = this.contentWidth = this.getContentWidth(true)
        if (contentWidth > parentWidth) {
          if (this.hasMinItem) {
            // 有节点小于最小宽度的时候
            // 这种情况只会存在于li总长度大于ul长度
            this.itemMaxWidth = ItemMaxWidth
            this.isShowlist = true
            this.setOffset(this.curbMap.length, parentWidth)
          } else if (ItemMaxWidth * this.curbMap.length > parentWidth) {
            this.isShowlist = true
            this.itemMaxWidth = ItemMaxWidth
            this.setOffset(this.curbMap.length, parentWidth)
          } else {
            this.isShowlist = false
            this.itemMaxWidth = 0
          }
          this.widerThanParent = true
          this.widthRate = (contentWidth / parentWidth) || 1
        } else {
          this.widerThanParent = false
          this.isShowlist = false
          this.widthRate = 1
        }
      })
    },
    // 切路径取数据
    getCurMapData(path) {
      const arrMap = path.split('/')
      const result = []
      arrMap.reduce((a, b) => {
        let path = `${a}\\${b}`
        if (a === '\\') path = a + b
        result.push({ path })
        return path
      }, '')
      return result
    },
    itemClick(e) {
      const target = e.target || e.srcElement
      const goBack = target.getAttribute('back')
      if (goBack) {
        this[goBack]()
        return
      }
      const index = target.getAttribute('index')
      const data = this.curbMap[index]
      this.$emit('crumbClick', { data, index })
      if (index) {
        this.$refs.crumbMore && this.$refs.crumbMore.closeList()
        this.$nextTick(() => {
          this.setListWidth()
        })
      }
    },
    // 窗口缩放回调
    resizeHandler() {
      if (this.timeHandler) {
        clearTimeout(this.timeHandler)
      }
      setTimeout(() => {
        this.$emit('refreshCrumb')
        this.$nextTick(() => {
          this.setListWidth()
        })
      }, 200)
    },
    // 点击返回
    goBack() {
      this.$emit('goBack')
      this.$nextTick(() => {
        this.setListWidth()
      })
    },
  },
  destoryed() {
    window.removeEventListener('resize', this.resizeHandler)
  },
}
</script>

<style lang="less">
@import '~less/crumb.less';
</style>
